export const SET_OPEN_TAB = "SET_OPEN_TAB";
export const SET_TV_SEC_MODE = "SET_TV_SEC_MODE";
